export const toolsetCards = [
			{
				title: 'ydata-profiling (formerly Pandas Profiling)',
				shortdescription:
					'Generates automated data profiling reports from pandas DataFrames.',
				description:
					'An open source Python library that generates detailed exploratory data analysis reports from pandas DataFrames. It automatically analyzes datasets to provide statistics, correlations, missing values, distributions, and other key insights through an interactive HTML report. Useful for quick data understanding and quality assessment in data science workflows.',
				category: 'Data Analysis & Profiling',
				license: 'MIT',
				githubLink: 'https://github.com/ydataai/ydata-profiling'
			},
			{
				title: 'Dask',
				shortdescription:
					'Parallel computing library that scales Python analytics from laptops to clusters.',
				description:
					'Dask is a flexible parallel computing library for analytics that provides advanced parallelism for Python analytics, enabling performance at scale for dataframes, arrays, and general computing. It integrates with the PyData ecosystem (NumPy, Pandas, Scikit-learn) and scales from laptops to clusters, providing a familiar interface for working with big data.',
				category: 'Distributed Computing & Data Processing',
				license: 'BSD 3-Clause',
				githubLink: 'https://github.com/dask/dask'
			},
			{
				title: 'Featuretools',
				shortdescription:
					'Performs automated feature engineering using Deep Feature Synthesis.',
				description:
					'An open source python framework for automated feature engineering. It excels at transforming temporal and relational datasets into feature matrices for machine learning. The tool automatically creates meaningful features from raw temporal and relational datasets through a process called Deep Feature Synthesis (DFS).',
				category: 'Data Processing & Feature Engineering',
				license: 'BSD-3-Clause',
				githubLink: 'https://github.com/alteryx/featuretools'
			},
			{
				title: 'Ray',
				shortdescription:
					'Framework for building distributed AI and Python applications.',
				description:
					"Ray is a unified framework for scaling AI and Python applications. It provides a simple, universal API for building distributed applications. Ray enables parallel and distributed computing capabilities for machine learning, serving, and general-purpose computing. It's particularly useful for distributed training of machine learning models, hyperparameter tuning, reinforcement learning, and scaling Python applications.",
				category: 'Distributed Computing Framework',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/ray-project/ray'
			},
			{
				title: 'MLflow',
				shortdescription:
					'Manages the end-to-end machine learning lifecycle.',
				description:
					'MLflow is an open source platform for managing the end-to-end machine learning lifecycle. It provides tools for tracking experiments, packaging code into reproducible runs, sharing and deploying models. Key features include experiment tracking, model registry, project packaging, and model serving capabilities.',
				category: 'MLOps',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/mlflow/mlflow'
			},
			{
				title: 'DVC (Data Version Control)',
				shortdescription:
					'Version control system for ML projects managing code and large data.',
				description:
					'DVC is a version control system for machine learning projects that manages both code and data. It works alongside Git to version large files, datasets, and machine learning models, while keeping them outside of Git. DVC implements pipelines for reproducible experiments and provides metrics tracking and visualization capabilities.',
				category: 'MLOps',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/iterative/dvc'
			},
			{
				title: 'Weights & Biases',
				shortdescription:
					'Tracks ML experiments and model performance collaboratively.',
				description:
					'A machine learning platform for experiment tracking, model versioning, and collaboration. It helps data scientists and ML engineers track experiments, visualize model performance, manage datasets, and collaborate with team members. Features include experiment tracking, model versioning, dataset versioning, model evaluation, and integration with popular ML frameworks.',
				category: 'MLOps',
				license: 'MIT',
				githubLink: 'https://github.com/wandb/wandb'
			},
			{
				title: 'Streamlit',
				shortdescription:
					'Easily builds interactive ML/data science web apps in Python.',
				description:
					'An open-source Python library that makes it easy to create and share beautiful, custom web apps for machine learning and data science. It allows data scientists and engineers to quickly build interactive dashboards and data applications without requiring extensive web development knowledge.',
				category: 'Data Visualization & Web Apps',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/streamlit/streamlit'
			},
			{
				title: 'Plotly',
				shortdescription:
					'Creates interactive, publication-quality visualizations in multiple languages.',
				description:
					'A comprehensive data visualization library that creates interactive, publication-quality graphs, charts, and dashboards. It supports multiple programming languages including Python, R, and JavaScript, and enables creation of web-based visualizations with features like zooming, panning, and hovering interactions. Particularly powerful for creating complex scientific charts, statistical plots, and financial visualizations.',
				category: 'Data Visualization',
				license: 'MIT',
				githubLink: 'https://github.com/plotly/plotly.py'
			},
			{
				title: 'Bokeh',
				shortdescription:
					'Builds interactive browser-based visualizations for large datasets.',
				description:
					'A powerful Python library for creating interactive visualizations and data applications in web browsers. It provides elegant, concise construction of versatile graphics with high-performance interactivity over large or streaming datasets.',
				category: 'Data Visualization',
				license: 'BSD-3-Clause',
				githubLink: 'https://github.com/bokeh/bokeh'
			},
			{
				title: 'Evidently AI',
				shortdescription:
					'Monitors ML model performance and detects data drift.',
				description:
					'An open-source Python library for ML model monitoring and evaluation. It helps data scientists and ML engineers analyze, validate, and monitor machine learning models in production. The tool generates interactive visual reports for data drift detection, model performance monitoring, and provides analytical insights about model behavior.',
				category: 'ML Model Monitoring',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/evidentlyai/evidently'
			},
			{
				title: 'FastAPI',
				shortdescription:
					'High-performance API framework based on Python type hints.',
				description:
					"FastAPI is a modern, fast web framework for building APIs with Python based on standard Python type hints. It's designed to be easy to use, fast to code, ready for production, and automatically generates interactive API documentation.",
				category: 'Web Framework',
				license: 'MIT',
				githubLink: 'https://github.com/tiangolo/fastapi'
			},
			{
				title: 'Sentence-Transformers',
				shortdescription:
					'Generates sentence and text embeddings for NLP tasks.',
				description:
					'A Python framework for state-of-the-art sentence, text and image embeddings. It enables easy computation of dense vector representations for sentences, paragraphs, and images, making it ideal for semantic search, clustering, and other NLP tasks. It provides pre-trained models that can be fine-tuned for specific use cases and supports multiple languages.',
				category: 'NLP & LLM Utilities',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/UKPLab/sentence-transformers'
			},
			{
				title: 'Label Studio',
				shortdescription:
					'Multi-format data labeling tool for ML training data.',
				description:
					'An open source data labeling tool for text, audio, images, videos, and time series data. It helps teams create high-quality training data for machine learning models by providing a flexible interface for manual data annotation, supporting multiple data types and annotation formats, and offering collaborative features for team-based labeling projects.',
				category: 'Data Labeling & Annotation',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/heartexlabs/label-studio'
			},
			{
				title: 'Pydub',
				shortdescription:
					'Simple interface for audio file manipulation in Python.',
				description:
					'A Python library for audio processing that allows manipulation of audio files with a simple and high-level interface. It supports operations like concatenation, trimming, format conversion, volume adjustment, and basic audio effects. Pydub can handle various audio formats including MP3, WAV, FLAC, and OGG.',
				category: 'Audio Processing Library',
				license: 'MIT',
				githubLink: 'https://github.com/jiaaro/pydub'
			},
			{
				title: 'pyAudioAnalysis',
				shortdescription:
					'Performs audio analysis, classification, and feature extraction.',
				description:
					'A Python library for audio feature extraction, classification of audio signals, and information retrieval. It provides functionality for audio segmentation, speaker diarization, music information retrieval, audio event detection, and content-based audio analysis. The library supports various audio processing tasks including beat extraction, thumbnailing, and classification of audio segments.',
				category: 'Audio Processing & Analysis',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/tyiannak/pyAudioAnalysis'
			},
			{
				title: 'Optuna',
				shortdescription:
					'Efficient hyperparameter optimization framework for ML.',
				description:
					'A hyperparameter optimization framework that automates the process of finding optimal hyperparameters for machine learning models. It implements various sampling algorithms like TPE (Tree-structured Parzen Estimators) and supports integration with popular ML frameworks like PyTorch, TensorFlow, and scikit-learn. It features distributed optimization, pruning of unpromising trials, and visualization tools for optimization history.',
				category: 'Machine Learning Optimization',
				license: 'MIT',
				githubLink: 'https://github.com/optuna/optuna'
			},
			{
				title: 'Ray Tune',
				shortdescription:
					'Scalable hyperparameter tuning library for ML frameworks.',
				description:
					'A scalable hyperparameter tuning library that integrates with major ML frameworks like PyTorch, TensorFlow, and XGBoost. It provides efficient search algorithms and scheduling for distributed hyperparameter optimization, supporting techniques like grid search, random search, Bayesian optimization, and population-based training.',
				category: 'Machine Learning Optimization',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/ray-project/ray'
			},
			{
				title: 'Apache Kafka',
				shortdescription:
					'Distributed platform for real-time event streaming.',
				description:
					"Apache Kafka is a distributed event streaming platform designed to handle high-throughput, fault-tolerant, real-time data feeds. It's used for building real-time streaming data pipelines and applications that adapt to data streams. Kafka combines messaging, storage, and stream processing to allow storing and processing of historical and real-time data.",
				category: 'Message Queue & Stream Processing',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/apache/kafka'
			},
			{
				title: 'Delta Lake',
				shortdescription:
					'Adds ACID transactions and schema enforcement to data lakes.',
				description:
					'An open-source storage layer that brings ACID transactions, scalable metadata handling, and unifies streaming and batch data processing on top of existing data lakes. It provides versioning, time travel, schema enforcement, and merge operations for data stored in cloud storage or HDFS.',
				category: 'Data Lake Storage',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/delta-io/delta'
			},
			{
				title: 'Apache Spark',
				shortdescription:
					'Unified analytics engine for big data processing.',
				description:
					'A unified analytics engine for large-scale data processing. It provides high-level APIs in Java, Scala, Python, and R, and supports various workloads including batch processing, real-time stream processing, machine learning, and SQL queries. Spark is designed for both speed and sophistication, running programs up to 100x faster than Hadoop MapReduce in memory.',
				category: 'Distributed Data Processing',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/apache/spark'
			},
			{
				title: 'Apache Zeppelin',
				shortdescription:
					'Web-based notebook for interactive data analytics.',
				description:
					'A web-based notebook environment that enables interactive data analytics and collaborative documents with SQL, Scala, Python, R and more. It provides built-in Apache Spark integration, visualization capabilities, and supports multiple interpreters for different programming languages and data processing frameworks.',
				category: 'Interactive Notebook Environment',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/apache/zeppelin'
			},
			{
				title: 'SHAP (SHapley Additive exPlanations)',
				shortdescription:
					'Explains ML model outputs using Shapley values.',
				description:
					'A game theoretic approach to explain the output of any machine learning model. It connects optimal credit allocation with local explanations using the classic Shapley values from game theory and their related extensions. SHAP provides various methods to interpret predictions from any machine learning model by computing feature importance and analyzing how each feature contributes to predictions.',
				category: 'Machine Learning Explainability',
				license: 'MIT',
				githubLink: 'https://github.com/slundberg/shap'
			},
			{
				title: 'Kubeflow',
				shortdescription: 'Manages ML workflows on Kubernetes.',
				description:
					'Kubeflow is a machine learning toolkit for Kubernetes that makes deploying and managing ML workflows on Kubernetes simple, portable, and scalable. It provides end-to-end orchestration of machine learning pipelines, including notebook servers, training jobs, hyperparameter tuning, model serving, and pipeline management. It enables data scientists to focus on ML while providing DevOps teams the tools to manage infrastructure and deployments.',
				category: 'MLOps & Orchestration',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/kubeflow/kubeflow'
			},
			{
				title: 'Apache Airflow',
				shortdescription:
					'Programmatically author, schedule, and monitor workflows.',
				description:
					"Apache Airflow is a platform to programmatically author, schedule, and monitor workflows. It allows users to create directed acyclic graphs (DAGs) of tasks and their dependencies, execute them on a defined schedule, and handle complex data pipeline dependencies. It's particularly popular for ETL processes, machine learning pipelines, and data warehouse operations.",
				category: 'Workflow Orchestration',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/apache/airflow'
			},
			{
				title: 'Grafana',
				shortdescription:
					'Visualizes time series data and infrastructure metrics.',
				description:
					'Grafana is an open-source analytics and interactive visualization web application. It provides charts, graphs, and alerts for the web when connected to supported data sources. It excels at visualizing time series data for infrastructure and application analytics but supports other data sources like SQL databases, CSV files, and JSON endpoints. Users can create dynamic dashboards with panels representing metrics over time.',
				category: 'Observability & Monitoring',
				license: 'AGPL-3.0',
				githubLink: 'https://github.com/grafana/grafana'
			},
			{
				title: 'Jenkins',
				shortdescription:
					'Automates build, test, and deployment pipelines.',
				description:
					'Jenkins is an open-source automation server that enables developers to build, test, and deploy their software. It provides hundreds of plugins to support building, deploying, and automating any project, including ML pipelines. Features include easy installation, simple configuration, extensible plugin ecosystem, distributed builds, and pipeline support through Jenkinsfile.',
				category: 'CI/CD',
				license: 'MIT License',
				githubLink: 'https://github.com/jenkinsci/jenkins'
			},
			{
				title: 'Kubernetes',
				shortdescription:
					'Manages and scales containerized applications.',
				description:
					'An open-source container orchestration platform that automates the deployment, scaling, and management of containerized applications. It groups containers into logical units for easy management and discovery, provides service discovery, load balancing, storage orchestration, automated rollouts and rollbacks, self-healing, and secret management.',
				category: 'Container Orchestration',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/kubernetes/kubernetes'
			},
			{
				title: 'Docker',
				shortdescription:
					'Packages applications into portable containers.',
				description:
					"Docker is a platform that enables developers to build, package, and distribute applications as lightweight containers. These containers bundle an application's code, configurations, and dependencies into a single object that can run consistently across any environment. Docker simplifies deployment, improves portability, and ensures consistency between development and production environments.",
				category: 'Containerization & Orchestration',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/docker/docker-ce'
			},
			{
				title: 'Terraform',
				shortdescription:
					'Infrastructure as Code tool for managing cloud resources.',
				description:
					'Terraform is a declarative Infrastructure as Code (IaC) tool that enables users to define and provision infrastructure resources across multiple cloud providers and services using HashiCorp Configuration Language (HCL) or JSON. It automates the creation, modification, and deletion of infrastructure resources while maintaining desired state and dependencies.',
				category: 'Infrastructure as Code',
				license: 'MPL-2.0',
				githubLink: 'https://github.com/hashicorp/terraform'
			},
			{
				title: 'Qdrant',
				shortdescription:
					'Vector search engine for semantic and neural search.',
				description:
					'Qdrant is a vector similarity search engine designed for production-grade applications. It provides a production-ready service with a convenient API to store, search, and manage points (vectors with payload) that represent your data objects. Particularly useful for neural network or semantic-based matching, similar image search, and other ML-powered matching applications.',
				category: 'Vector Database',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/qdrant/qdrant'
			},
			{
				title: 'Neo4j',
				shortdescription: 'Graph database for connected data analysis.',
				description:
					'Neo4j is a native graph database platform that provides a robust foundation for storing, querying, and analyzing connected data. It uses nodes and relationships to represent and store data in a graph structure, making it ideal for applications requiring complex queries on highly connected data, such as recommendation engines, fraud detection, knowledge graphs, and network analysis.',
				category: 'Graph Database',
				license: 'GPL v3',
				githubLink: 'https://github.com/neo4j/neo4j'
			},
			{
				title: 'Apache CloudStack',
				shortdescription:
					'Open-source platform for managing virtual machine clouds.',
				description:
					'Apache CloudStack is an open-source cloud computing platform designed to deploy and manage large networks of virtual machines as a highly available, scalable Infrastructure-as-a-Service (IaaS) cloud computing platform. It supports multiple hypervisors including KVM, VMware, and XenServer, and provides a feature-rich API and web interface for managing compute, storage, and networking resources.',
				category: 'Cloud Infrastructure Management',
				license: 'Apache License 2.0',
				githubLink: 'https://github.com/apache/cloudstack'
			},
			{
				title: 'Pyomo',
				shortdescription:
					'Builds optimization models for various mathematical problems.',
				description:
					"Pyomo is a Python-based open-source optimization modeling language that supports a diverse set of optimization capabilities for formulating, solving, and analyzing optimization models. It's particularly useful for linear programming, mixed-integer programming, nonlinear programming, and other optimization problems commonly found in operations research, supply chain optimization, and mathematical modeling.",
				category: 'Mathematical Optimization',
				license: 'BSD-3-Clause',
				githubLink: 'https://github.com/Pyomo/pyomo'
			},
			{
				title: 'OR-Tools',
				shortdescription: 'Solves combinatorial optimization problems.',
				description:
					"A fast and portable software suite for solving combinatorial optimization problems, including vehicle routing, flow problems, integer/linear programming, and constraint programming. It's particularly useful for solving complex logistics, scheduling, and resource allocation problems.",
				category: 'Optimization and Operations Research',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/google/or-tools'
			},
			{
				title: 'Apache Superset',
				shortdescription:
					'Explores and visualizes data via interactive dashboards.',
				description:
					'A modern, enterprise-ready business intelligence web application that enables users to explore and visualize their data through an intuitive interface. It offers a wide range of visualization options, supports multiple databases, features a rich SQL editor, and allows for interactive dashboard creation with advanced security controls.',
				category: 'Data Visualization & Business Intelligence',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/apache/superset'
			},
			{
				title: 'Dash',
				shortdescription:
					'Framework for creating analytical web apps and dashboards.',
				description:
					"A Python framework for building analytical web applications and interactive dashboards. Built on top of Plotly.js, React, and Flask, Dash allows data scientists and analysts to create web-based data visualization interfaces without extensive web development knowledge. It's particularly powerful for creating complex data visualizations, scientific applications, and IoT dashboards.",
				category: 'Data Visualization & Web Dashboards',
				license: 'MIT',
				githubLink: 'https://github.com/plotly/dash'
			},
			{
				title: 'Selenium',
				shortdescription: 'Automates browser tasks and testing.',
				description:
					'Selenium is a portable framework for automated testing of web applications across different browsers and platforms. It provides a suite of tools for browser automation that can be used for testing web applications, web scraping, and browser-based task automation. It supports multiple programming languages including Python, Java, C#, Ruby, and JavaScript.',
				category: 'Test Automation',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/SeleniumHQ/selenium'
			},
			{
				title: 'CKAN',
				shortdescription: 'Manages and shares open data in catalogs.',
				description:
					'CKAN is an open-source data management system that makes data accessible by providing tools to streamline publishing, sharing, finding and using data. It is primarily used for creating open data websites and portals, serving as a data catalog and repository. It includes features for data hosting, metadata management, data preview, and API access.',
				category: 'Data Catalog Platform',
				license: 'AGPL-3.0',
				githubLink: 'https://github.com/ckan/ckan'
			},
			{
				title: 'OpenAPI Specification',
				shortdescription: 'Standard for defining and documenting APIs.',
				description:
					'A standardized, language-agnostic interface description for HTTP APIs that allows both humans and computers to discover and understand the capabilities of a service without requiring access to source code or additional documentation. It enables developers to define RESTful APIs using a declarative format, making it easier to document, test, and generate client SDKs.',
				category: 'API Development',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/OAI/OpenAPI-Specification'
			},
			{
				title: 'LangChain',
				shortdescription:
					'Framework for building applications using language models.',
				description:
					'A framework for developing applications powered by language models. It provides tools and abstractions for chaining together LLM calls, managing prompts, handling context, integrating with external data sources, and creating autonomous agents. LangChain enables developers to build complex LLM applications by composing different components and chains.',
				category: 'LLM Frameworks & Orchestration',
				license: 'MIT',
				githubLink: 'https://github.com/langchain-ai/langchain'
			},
			{
				title: 'LangFlow',
				shortdescription:
					'Drag-and-drop GUI for prototyping LLM workflows.',
				description:
					'A GUI for LangChain that enables users to experiment and prototype LLM applications through a drag-and-drop interface. It allows visual creation of LangChain pipelines, making it easier to build complex language model workflows without writing code.',
				category: 'LLM Development & Orchestration',
				license: 'MIT',
				githubLink: 'https://github.com/logspace-ai/langflow'
			},
			{
				title: 'Transformers Agents',
				shortdescription: 'Creates LLM agents capable of using tools.',
				description:
					'A framework within Hugging Face Transformers that enables the creation of AI agents capable of using tools and making decisions. It allows developers to build autonomous agents that can understand natural language instructions, interact with various tools and APIs, and execute complex tasks by breaking them down into smaller steps. The framework provides a flexible way to combine language models with custom tools and external functionalities.',
				category: 'LLM Frameworks & Orchestration',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/huggingface/transformers'
			},
			{
				title: 'Chroma',
				shortdescription:
					'Lightweight vector database for AI embeddings.',
				description:
					'An open-source embedding database for building AI applications with vector search. It allows developers to store, embed, and search through text, images, and other embeddings. Chroma is designed to be lightweight, easy to use, and particularly well-suited for RAG (Retrieval Augmented Generation) applications and LLM-based systems.',
				category: 'Vector Database',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/chroma-core/chroma'
			},
			{
				title: 'Weaviate',
				shortdescription:
					'Scalable vector database with semantic search.',
				description:
					"Weaviate is an open-source vector database that allows you to store data objects and vector embeddings from various ML-models. It offers semantic search, automatic classification, and real-time vector indexing with support for GraphQL, REST, and various programming languages. It's designed to scale horizontally and handle large-scale vector search operations with low latency.",
				category: 'Vector Database',
				license: 'BSD-3-Clause',
				githubLink: 'https://github.com/weaviate/weaviate'
			},
			{
				title: 'Langroid',
				shortdescription:
					'Framework for building multi-agent LLM applications.',
				description:
					'A Python framework for building multi-agent applications with Large Language Models (LLMs). It provides a flexible and modular way to create conversational AI agents that can interact with each other and external tools, featuring built-in support for various LLM providers, structured output parsing, and tool integration.',
				category: 'LLM Development',
				license: 'MIT',
				githubLink: 'https://github.com/langroid/langroid'
			},
			{
				title: 'DeepEval',
				shortdescription:
					'Evaluates LLM outputs for quality and reliability.',
				description:
					'A comprehensive evaluation framework for testing LLM applications. It provides tools for evaluating LLM outputs across various dimensions including accuracy, latency, and reliability. Supports automated testing of prompts, RAG systems, and end-to-end LLM applications with features like semantic similarity checking and hallucination detection.',
				category: 'ML Testing & Evaluation',
				license: 'MIT',
				githubLink: 'https://github.com/confident-ai/deepeval'
			},
			{
				title: 'HELM',
				shortdescription:
					'Benchmarks LLMs across multiple performance dimensions.',
				description:
					'HELM (Holistic Evaluation of Language Models) is a framework for rigorously evaluating Large Language Models (LLMs) across multiple dimensions including accuracy, calibration, robustness, fairness, bias, and toxicity. It provides standardized benchmarks and metrics to assess language model capabilities and limitations.',
				category: 'Machine Learning Evaluation',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/stanford-crfm/helm'
			},
			{
				title: 'QLoRA',
				shortdescription:
					'Memory-efficient fine-tuning for large language models.',
				description:
					'QLoRA (Quantized Low-Rank Adaptation) is a memory-efficient fine-tuning approach for large language models. It enables fine-tuning large language models on a single GPU by using 4-bit quantization and low-rank adaptation techniques. QLoRA maintains model quality while significantly reducing memory requirements compared to full fine-tuning.',
				category: 'LLM Training & Optimization',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/artidoro/qlora'
			},
			{
				title: 'Deepchecks',
				shortdescription:
					'Tests ML models and data for validation and monitoring.',
				description:
					'A Python package for testing and validating machine learning models and data. It performs comprehensive checks on data quality, model performance, and model behavior across the ML lifecycle, helping detect issues like data leakage, concept drift, and model degradation.',
				category: 'ML Testing & Validation',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/deepchecks/deepchecks'
			},
			{
				title: 'Presidio',
				shortdescription:
					'Detects and anonymizes sensitive information in data.',
				description:
					"Presidio is a context-aware data protection and anonymization service for identifying and redacting sensitive data in text and images. It uses advanced NLP and pattern recognition to detect and handle PII (Personally Identifiable Information) like credit card numbers, phone numbers, addresses, and other sensitive data types. It's particularly useful for GDPR compliance and data security implementations.",
				category: 'Data Privacy & Security',
				license: 'MIT',
				githubLink: 'https://github.com/Microsoft/presidio'
			},
			{
				title: 'PyTorch Profiler',
				shortdescription:
					'Analyzes PyTorch model performance and resource use.',
				description:
					'A performance profiling tool for PyTorch that helps developers understand the computational performance and resource utilization of their deep learning models. It provides detailed insights into CPU/GPU execution time, memory consumption, operator-level statistics, and traces that can be visualized in tools like TensorBoard or Chrome Tracing.',
				category: 'Performance Optimization',
				license: 'BSD-3-Clause',
				githubLink: 'https://github.com/pytorch/pytorch'
			},
			{
				title: 'TensorFlow Profiler',
				shortdescription:
					'Monitors and optimizes TensorFlow model performance.',
				description:
					'A performance profiling and optimization tool for TensorFlow models that helps developers understand model performance, identify bottlenecks, and optimize execution. It provides insights into GPU/CPU utilization, memory usage, operation execution time, and model architecture through features like trace viewer, input pipeline analyzer, and memory viewer.',
				category: 'Performance Optimization & Profiling',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/tensorflow/tensorflow'
			},
			{
				title: 'OpenSearch',
				shortdescription:
					'Search and analytics engine for log and app data.',
				description:
					"OpenSearch is a distributed, open-source search and analytics engine derived from Elasticsearch 7.10.2. It supports full-text search, document storage, real-time analytics, and visualization capabilities. It's commonly used for log analytics, application search, security analytics, and observability.",
				category: 'Search Engine & Analytics',
				license: 'Apache-2.0',
				githubLink: 'https://github.com/opensearch-project/OpenSearch'
			}
		];